import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@/store/auth';
import { api, type Parroquia } from '@/lib/api';

function CoverageBar({ value }: { value: number }) {
  return (
    <div style={{ height: 4, background: 'rgba(255,255,255,0.1)', borderRadius: 2, overflow: 'hidden' }}>
      <div style={{ height: '100%', width: `${value}%`, background: `linear-gradient(90deg,#60A5FA,#1D4ED8)`, borderRadius: 2, transition: 'width 800ms ease' }} />
    </div>
  );
}

export default function Territorio() {
  const { token } = useAuthStore();
  const { data: parroquias = [], isLoading } = useQuery<Parroquia[]>({
    queryKey: ['parroquias'],
    queryFn: () => api.parroquias(token!),
    enabled: !!token,
  });

  return (
    <div style={{ position: 'absolute', inset: 0, overflowY: 'auto', paddingTop: 90, paddingBottom: 90 }}>
      <div style={{ padding: '16px 16px 0', maxWidth: 800, margin: '0 auto' }}>
        <h2 style={{ fontSize: 20, fontWeight: 800, color: '#0A1628', margin: '0 0 4px' }}>Territorio</h2>
        <p style={{ fontSize: 12.5, color: 'rgba(10,22,40,0.5)', margin: '0 0 20px' }}>Vista general por parroquias</p>

        {isLoading && (
          <div style={{ textAlign: 'center', padding: 40, color: 'rgba(10,22,40,0.4)', fontSize: 13 }}>Cargando…</div>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(220px,1fr))', gap: 12 }}>
          {parroquias.map(p => (
            <div key={p.id} style={{ background: 'rgba(255,255,255,0.7)', backdropFilter: 'blur(12px)', borderRadius: 18, padding: 18, border: '1px solid rgba(255,255,255,0.6)', boxShadow: '0 4px 16px rgba(30,58,138,0.07)' }}>
              {/* Header */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{ width: 10, height: 10, borderRadius: '50%', background: p.color }} />
                  <span style={{ fontSize: 13, fontWeight: 700, color: '#0A1628' }}>{p.nombre}</span>
                </div>
                <span style={{ fontSize: 9.5, color: 'rgba(10,22,40,0.4)', background: 'rgba(10,22,40,0.06)', padding: '2px 7px', borderRadius: 20 }}>{p.tipo}</span>
              </div>

              {/* Stats */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 12 }}>
                <div style={{ background: 'rgba(10,22,40,0.04)', borderRadius: 10, padding: '8px 10px' }}>
                  <div style={{ fontSize: 15, fontWeight: 800, color: '#0A1628' }}>{p.hab}</div>
                  <div style={{ fontSize: 9, color: 'rgba(10,22,40,0.4)' }}>Habitantes</div>
                </div>
                <div style={{ background: 'rgba(10,22,40,0.04)', borderRadius: 10, padding: '8px 10px' }}>
                  <div style={{ fontSize: 15, fontWeight: 800, color: '#0A1628' }}>{p.circuitos}</div>
                  <div style={{ fontSize: 9, color: 'rgba(10,22,40,0.4)' }}>Circuitos</div>
                </div>
              </div>

              {/* Coverage */}
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                  <span style={{ fontSize: 10, color: 'rgba(10,22,40,0.5)' }}>Cobertura</span>
                  <span style={{ fontSize: 10, fontWeight: 700, color: '#1D4ED8' }}>{p.cobertura}%</span>
                </div>
                <CoverageBar value={p.cobertura} />
              </div>

              {p.activos > 0 && (
                <div style={{ marginTop: 10, display: 'flex', alignItems: 'center', gap: 5 }}>
                  <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#ef4444' }} />
                  <span style={{ fontSize: 10, color: '#ef4444', fontWeight: 600 }}>{p.activos} reportes activos</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
